var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.000000pt",
    height: "10.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1865 5114 c-207 -20 -364 -52 -522 -108 -712 -248 -1212 -860 -1324 -1621 -19 -126 -16 -433 5 -564 69 -437 262 -820 564 -1118 386 -383 873 -583 1417 -583 377 0 764 111 1065 306 39 25 73 44 74 42 1 -1 11 -25 21 -53 10 -27 31 -68 46 -90 15 -22 301 -313 636 -647 662 -661 643 -644 783 -670 124 -23 269 24 363 119 95 94 142 239 119 363 -26 140 -9 121 -670 783 -334 335 -625 621 -647 636 -22 15 -62 36 -90 46 -27 10 -51 20 -53 21 -2 1 19 38 47 82 198 316 301 678 301 1057 0 541 -198 1025 -576 1411 -297 302 -681 498 -1114 569 -94 15 -367 27 -445 19z m353 -519 c236 -35 478 -133 662 -268 523 -384 739 -1049 543 -1672 -110 -349 -378 -671 -710 -852 -354 -193 -805 -231 -1188 -101 -970 331 -1329 1515 -706 2327 281 365 707 576 1174 580 70 0 171 -6 225 -14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.754450ecb06b956a625b3b41faba6bd9.svg";
export { ForwardRef as ReactComponent };